export default "__VITE_ASSET__6e2fa72c__"